import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=72165c9c&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=ts"
export * from "./Toolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72165c9c",
  null
  
)

export default component.exports